module.exports = __webpack_public_path__ + "img/erskine_b1.40414c5b.jpg";